<template>
  <div :class="showBackgroundColor ? 'footer font12 bc' : 'footer font12'">
    未经日浩同意，不得转载本网站之所有招聘信息 日浩版权所有 ©

    <span style="font-family: Arial">2005-{{ year }} </span>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    showBackgroundColor: Boolean,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped lang="less">
.footer {
  display: block;
  width: 100vw;
  text-align: center;
  color: #000;
  line-height: 0.1rem;
  padding: 0.2rem 2.5%;
  box-sizing: border-box;
  background-color: #fff;
  font-size: 0.1rem;
}
.bc {
  color: #fff;

  background-color: rgb(10, 150, 221);
}
.hand {
  width: 0.1rem;
  margin-right: 0.1rem;
}
</style>
